// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"trust-pilot-link-module--wrapper--r6T2E","mobileWidget":"trust-pilot-link-module--mobileWidget--308GU","desktopWidget":"trust-pilot-link-module--desktopWidget--2bfja"};